import { Sort } from '../../UI-Components/Sort/sort';

export class SearchPublicationHistoryModel {
    constructor(public publishingId: string, public type: string, public subType: string, public pageSize: number, public page: number, public sort: Sort) {
        }
}
